module.exports = __webpack_public_path__ + "img/lesson.87a6da00.jpg";